export const SETTING_URL = "setting";

export const GET_EMAIL_LIST_URL = `email/list`;
export const GET_EMAIL_VIEW_URL = `email/view`;

export const GET_CATEGORY_LIST_URL = `category/list`;
export const GET_CATEGORY_VIEW_URL = `category/view`;
export const GET_CATEGORY_SORT_LIST = `category/sort`;
export const PUT_CATEGORY_UPDATE = `category/update`;
export const GET_CATEGORY_REVIEWER_LIST = `reviewer/list`;
export const GET_CATEGORY_REVIEWER_ADD = `reviewer/insert`;
export const GET_CATEGORY_REVIEWER_DELETE = `reviewer/delete`;
export const GET_CATEGORY_REVIEWER_UPDATE = `reviewer/update`;

export const GET_ACTIVITY_LIST_URL = `activity/list`;

// Mail Template
export const MAIL_TEMPLATE_GET_LIST_URL = `email/list`;
export const MAIL_TEMPLATE_GET_VIEW_URL = `email/view`;
export const MAIL_TEMPLATE_ADD_URL = `email/insert`;
export const MAIL_TEMPLATE_UPDATE_URL = `email/update`;
export const MAIL_TEMPLATE_DELETE_URL = `email/delete`;

// Manager
export const GET_MANAGER_LIST_URL = "permission/list";
export const INSERT_MANAGER_URL = "permission/insert";
export const DELETE_MANAGER_URL = "permission/delete";
